import { useWebsiteIDXLoading, useWebsiteIDXUrl } from "../../reducers/websiteReducer/selectors";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";
import NoPermission from "../shared/NoPermission";
import NoWebsites from "../shared/NoWebsites";
import Roster from "./Roster";

const RosterIndex = () => {
  const currentUser = useCurrentUser();
  const idxLoading = useWebsiteIDXLoading();
  const idxUrl = useWebsiteIDXUrl();

  let content = <Roster />;
  if (!currentUser.account.isAdmin) {
    content = (
      <div className="tw-flex-1 tw-h-full tw-max-w-[1416px] tw-mx-auto tw-flex tw-gap-[32px]">
        <div className="tw-relative tw-w-full tw-flex tw-flex-col tw-gap-[32px] tw-m-[16px] tw-bg-white tw-border-[1px] tw-border-solid tw-border-gray-10 tw-rounded-[8px] tw-p-[32px] tw-overflow-auto">
          <NoPermission />
        </div>
      </div>
    );
  } else if (!idxLoading && !idxUrl) {
    content = (
      <div className="tw-flex-1 tw-h-full tw-max-w-[1416px] tw-mx-auto tw-flex tw-gap-[32px]">
        <div className="tw-relative tw-w-full tw-flex tw-flex-col tw-gap-[32px] tw-m-[16px] tw-bg-white tw-border-[1px] tw-border-solid tw-border-gray-10 tw-rounded-[8px] tw-p-[32px] tw-overflow-auto">
          <NoWebsites target="roster" />
        </div>
      </div>
    );
  }

  return content;
};

export default RosterIndex;
